import React from 'react';
import { View, Text } from '@react-pdf/renderer';

import { AssessmentAnswer } from '../../../../../generated/graphql';

import { isStatementAssessmentQuestion } from '../../../../lib/assessments';
import { ProgramAssessmentQuestion } from '../../../../lib/program-assessment';
import { createQuestionsForDisplay } from '../../../../lib/assessment-responses';

import { QuestionSubscale } from '../../../Assessments/QuestionsSection';
import { findAnswerForQuestion } from '../../../Assessments/ResponsesSection/helpers';

import PdfFormattedText from '../../../Library/LibraryFormPDF/components/PdfFormattedText';
import { getAnswerContent } from '../helpers';
import { styles } from '../index';
import { colors } from '../../../../lib/colors';

interface ResponsesSectionProps {
  questions: ProgramAssessmentQuestion[] | undefined;
  answers: AssessmentAnswer[] | undefined;
  isForm: boolean;
}

const ResponsesSection: React.FC<ResponsesSectionProps> = ({
  questions,
  answers,
  isForm,
}) => {
  // Create questions for display, pairing answers by index (not question text).
  const orderedQuestions = createQuestionsForDisplay(questions, answers ?? []);

  return (
    <View>
      <Text style={styles.sectionTitle}>Responses</Text>
      {orderedQuestions.map(
        (
          { question: templateQuestion, questionText, matchedAnswer },
          questionIndex,
        ) => {
          const answer =
            matchedAnswer ??
            findAnswerForQuestion(answers ?? [], {
              question: questionText,
              questionType: templateQuestion?.questionType,
            });
          const answerContent = getAnswerContent(answer, templateQuestion);
          const isStatementQuestion = templateQuestion
            ? isStatementAssessmentQuestion(templateQuestion)
            : false;

          if (isForm) {
            return (
              <React.Fragment key={questionIndex}>
                {!isStatementQuestion ? (
                  <View
                    style={{
                      marginBottom: 12,
                      borderColor: colors.neutral[75],
                      borderWidth: 1,
                      borderRadius: 8,
                      padding: 12,
                    }}
                  >
                    <View
                      style={{
                        borderBottomWidth: 1,
                        borderBottomColor: colors.neutral[50],
                        borderBottomStyle: 'solid',
                        width: '100%',
                        paddingBottom: 4,
                        marginBottom: 8,
                      }}
                    >
                      <PdfFormattedText
                        style={[styles.questionText, { marginBottom: 4 }]}
                      >
                        {questionText}
                      </PdfFormattedText>
                    </View>
                    {answerContent}
                  </View>
                ) : (
                  <PdfFormattedText
                    style={[styles.questionText, { marginBottom: 4 }]}
                  >
                    {questionText}
                  </PdfFormattedText>
                )}
              </React.Fragment>
            );
          } else {
            return (
              <View key={questionIndex} style={styles.assessmentQuestion}>
                <View style={styles.questionNumberContainer}>
                  <Text style={styles.questionNumber}>{`${
                    questionIndex + 1
                  }.`}</Text>
                </View>
                <View style={{ flex: 1 }}>
                  <PdfFormattedText style={styles.questionText}>
                    {questionText}
                  </PdfFormattedText>
                  {answerContent}
                  {!answer &&
                    templateQuestion &&
                    !isStatementAssessmentQuestion(templateQuestion) && (
                      <Text style={styles.answerText}>
                        {QuestionSubscale[templateQuestion.questionType]}
                      </Text>
                    )}
                </View>
              </View>
            );
          }
        },
      )}
    </View>
  );
};

export default ResponsesSection;
